/**
 * Utility functions for Book Now submissions (admin)
 */

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

export const getBookNowSubmissions = async () => {
  const res = await fetch(`${API_BASE}/register/bookings`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error("Failed to fetch bookings");
  }
  const json = await res.json();
  if (!json.ok) {
    throw new Error(json.error || "Failed to fetch bookings");
  }
  return Array.isArray(json.data) ? json.data : [];
};

